/* COMMON */
export const RESET = "RESET";
export const FORCE_RELOAD = "FORCE_RELOAD";

/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const HOTEL_SETTINGS_GET = "HOTEL_SETTINGS_GET";
export const HOTEL_SETTINGS_SUCCESS = "HOTEL_SETTINGS_SUCCESS";
export const HOTEL_SETTINGS_ERROR = "HOTEL_SETTINGS_ERROR";
export const SHOW_TOAST_SET = "SHOW_TOAST_SET";

export const GROUP_NAMES_GET = "GROUP_NAMES_GET";
export const GROUP_NAMES_GET_SUCCESS = "GROUP_NAMES_GET_SUCCESS";
export const GROUP_NAMES_GET_ERROR = "GROUP_NAMES_GET_ERROR";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const CONFIRM_USER = "CONFIRM_USER";
export const CONFIRM_USER_SUCCESS = "CONFIRM_USER_SUCCESS ";
export const LOGOUT_USER = "LOGOUT_USER";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_AUTHSTATE = "UPDATE_AUTHSTATE";
export const UPDATE_AUTHDATA = "UPDATE_AUTHDATA";

export const USER_PRIVILEGES_GET = "USER_PRIVILEGES_GET";
export const USER_PRIVILEGES_GET_SUCCESS = "USER_PRIVILEGES_GET_SUCCESS";
export const USER_PRIVILEGES_GET_ERROR = "USER_PRIVILEGES_GET_ERROR";

export const SET_AMPLIFY_CONFIG_STATUS = "SET_AMPLIFY_CONFIG_STATUS";
export const WEBPUSH_PERMISSION_START = "WEBPUSH_PERMISSION_START";
export const WEBPUSH_PERMISSION_ERROR = "WEBPUSH_PERMISSION_ERROR";
export const WEBPUSH_PERMISSION_SUCCESS = "WEBPUSH_PERMISSION_SUCCESS";

export const APP_PUSH_TOKEN_SUCCESS = "APP_PUSH_TOKEN_SUCCESS";

/* IOT */
export const ATTACH_CONNECT_POLICY = "ATTACH_CONNECT_POLICY";
export const ATTACH_CONNECT_POLICY_SUCCESS = "ATTACH_CONNECT_POLICY_SUCCESS";
export const ATTACH_CONNECT_POLICY_ERROR = "ATTACH_CONNECT_POLICY_ERROR";
export const ATTACH_PUBLIC_PUBLISH_POLICY = "ATTACH_PUBLIC_PUBLISH_POLICY";
export const ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS = "ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS";
export const ATTACH_PUBLIC_PUBLISH_POLICY_ERROR = "ATTACH_PUBLIC_PUBLISH_POLICY_ERROR";
export const ATTACH_SUBSCRIBE_POLICY = "ATTACH_SUBSCRIBE_POLICY";
export const ATTACH_SUBSCRIBE_POLICY_SUCCESS = "ATTACH_SUBSCRIBE_POLICY_SUCCESS";
export const ATTACH_SUBSCRIBE_POLICY_ERROR = "ATTACH_SUBSCRIBE_POLICY_ERROR";
export const ATTACH_PUBLIC_RECEIVE_POLICY = "ATTACH_PUBLIC_RECEIVE_POLICY";
export const ATTACH_PUBLIC_RECEIVE_POLICY_SUCCESS = "ATTACH_PUBLIC_RECEIVE_POLICY_SUCCES";
export const ATTACH_PUBLIC_RECEIVE_POLICY_ERROR = "ATTACH_PUBLIC_RECEIVE_POLICY_ERROR";
export const INTERNET_CONNECTED_STATUS_CHANGED = "INTERNET_CONNECTED_STATUS_CHANGED";
export const SET_DEVICE_STATUS = "SET_DEVICE_STATUS";
export const MESSAGE_HANDLER_ATTACHED = "MESSAGE_HANDLER_ATTACHED";
export const ON_NEW_MESSAGE_TRIGGERED = "ON_NEW_MESSAGE_TRIGGERED";
export const SET_IOT_CLIENT_ID = "SET_IOT_CLIENT_ID";
export const UNSUBSCRIBE_FROM_TOPICS = "UNSUBSCRIBE_FROM_TOPICS";

export const IOT_CONNECT_CALLBACK_START = "IOT_CONNECT_CALLBACK_START";
export const IOT_CONNECT_CALLBACK_SUCCESS = "IOT_CONNECT_CALLBACK_SUCCESS";
export const IOT_CONNECT_CALLBACK_ERROR = "IOT_CONNECT_CALLBACK_ERROR";

export const IOT_CLOSE_CALLBACK_START = "IOT_CLOSE_CALLBACK_START";
export const IOT_CLOSE_CALLBACK_SUCCESS = "IOT_CLOSE_CALLBACK_SUCCESS";
export const IOT_CLOSE_CALLBACK_ERROR = "IOT_CLOSE_CALLBACK_ERROR";

export const IOT_ERROR_OCCURRED = "IOT_ERROR_OCCURRED";

export const ADD_SUBSCRIBED_TOPIC = "ADD_SUBSCRIBED_TOPIC";
export const CLEAR_SUBSCRIBED_TOPICS = "CLEAR_SUBSCRIBED_TOPICS";
export const CLEAR_POLICIES = "CLEAR_POLICIES";
export const ACQUIRE_POLICIES_START = "ACQUIRE_POLICIES_START";
export const ACQUIRE_POLICIES_SUCCESS = "ACQUIRE_POLICIES_SUCCESS";
export const ACQUIRE_POLICIES_ERROR = "ACQUIRE_POLICIES_ERROR";
export const ADD_SUBSCRIBED_TOPIC_ERROR = "ADD_SUBSCRIBED_TOPIC_ERROR";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/* REQUESTAPP */
export const ALACARTE_REQUEST_GET_BY_ID = "ALACARTE_REQUEST_GET_BY_ID";
export const ALACARTE_REQUEST_GET_BY_ID_SUCCESS = "ALACARTE_REQUEST_GET_BY_ID_SUCCESS";
export const ALACARTE_REQUEST_GET_BY_ID_ERROR = "ALACARTE_REQUEST_GET_BY_ID_ERROR";
export const ALACARTE_REQUEST_GET_LIST = "ALACARTE_REQUEST_GET_LIST";
export const ALACARTE_REQUEST_GET_LIST_SUCCESS = "ALACARTE_REQUEST_GET_LIST_SUCCESS";
export const ALACARTE_REQUEST_GET_LIST_ERROR = "ALACARTE_REQUEST_GET_LIST_ERROR";
export const ALACARTE_REQUEST_GET_LIST_WITH_FILTER = "ALACARTE_REQUEST_GET_LIST_WITH_FILTER";
export const ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS = "ALACARTE_REQUEST_GET_LIST_WITH_FILTER_SUCCESS";
export const ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR = "ALACARTE_REQUEST_GET_LIST_WITH_FILTER_ERROR";

export const REQUEST_GET_LIST_DELTA = "REQUEST_GET_LIST_DELTA";
export const REQUEST_GET_LIST_DELTA_SUCCESS = "REQUEST_GET_LIST_DELTA_SUCCESS";
export const REQUEST_GET_LIST_DELTA_ERROR = "REQUEST_GET_LIST_DELTA_ERROR";
export const REQUEST_GET_LIST_WITH_FILTER = "REQUEST_GET_LIST_WITH_FILTER";
export const REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER = "REQUEST_GET_FAST_CHECK_IN_LIST_WITH_FILTER";
export const REQUEST_GET_ALACARTE_LIST_WITH_FILTER = "REQUEST_GET_ALACARTE_LIST_WITH_FILTER";
export const REQUEST_GET_ALACARTE_STATUS_FILTER = "REQUEST_GET_ALACARTE_STATUS_FILTER";
export const REQUEST_GET_ALACARTE_LIST_WITH_ORDER = "REQUEST_GET_ALACARTE_LIST_WITH_ORDER";
export const REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT = "REQUEST_GET_ALACARTE_LIST_WITH_RESTAURANT";
export const REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER = "REQUEST_GET_FAST_CHECK_IN_LIST_WITH_ORDER";
export const REQUEST_GET_LIST_WITH_ORDER = "REQUEST_GET_LIST_WITH_ORDER";
export const REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH = "REQUEST_GET_FAST_CHECK_IN_LIST_SEARCH";
export const REQUEST_GET_LIST_SEARCH = "REQUEST_GET_LIST_SEARCH";

export const REQUEST_ADD_ITEM = "REQUEST_ADD_ITEM";
export const REQUEST_ADD_ITEM_SUCCESS = "REQUEST_ADD_ITEM_SUCCESS";
export const REQUEST_ADD_ITEM_ERROR = "REQUEST_ADD_ITEM_ERROR";
export const REQUEST_SELECTED_ITEMS_CHANGE = "REQUEST_SELECTED_ITEMS_CHANGE";
export const CHANGE_LANGUAGE_FOR_REQUEST_ITEMS = "CHANGE_LANGUAGE_FOR_REQUEST_ITEMS";
export const COMMENT_ADD_ITEM = "COMMENT_ADD_ITEM";
export const COMMENT_ADD_ITEM_SUCCESS = "COMMENT_ADD_ITEM_SUCCESS";
export const COMMENT_ADD_ITEM_ERROR = "COMMENT_ADD_ITEM_ERROR";
export const REQUEST_GET_ITEM = "REQUEST_GET_ITEM";
export const REQUEST_GET_ITEM_SUCCESS = "REQUEST_GET_ITEM_SUCCESS";
export const REQUEST_GET_ITEM_ERROR = "REQUEST_GET_ITEM_ERROR";
export const SET_IS_TRANSLATION_NEEDED = "SET_IS_TRANSLATION_NEEDED";
export const REQUEST_SHOW_TOAST_SET = "REQUEST_SHOW_TOAST_SET";
export const REQUEST_CREATE_QR_IMAGE = "REQUEST_CREATE_QR_IMAGE";
export const REQUEST_CREATE_QR_IMAGE_SUCCESS = "REQUEST_CREATE_QR_IMAGE_SUCCESS";
export const REQUEST_CREATE_QR_IMAGE_ERROR = "REQUEST_CREATE_QR_IMAGE_ERROR";
export const REQUEST_CREATE_QR_IMAGE_DEEP_LINK = "REQUEST_CREATE_QR_IMAGE_DEEP_LINK";
export const REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS = "REQUEST_CREATE_QR_IMAGE_DEEP_LINK_SUCCESS";
export const REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR = "REQUEST_CREATE_QR_IMAGE_DEEP_LINK_ERROR";
export const SET_REQUEST_LOADING = "SET_REQUEST_LOADING";

/* ALACARTE */
export const REQUEST_GET_LIST_RESTAURANT = "REQUEST_GET_LIST_RESTAURANT";
export const REQUEST_GET_LIST_RESTAURANT_SUCCESS = "REQUEST_GET_LIST_RESTAURANT_SUCCESS";
export const REQUEST_GET_LIST_RESTAURANT_ERROR = "REQUEST_GET_LIST_RESTAURANT_ERROR";
export const REQUEST_GET_SEATS_AND_SLOTS = "REQUEST_GET_SEATS_AND_SLOTS";
export const REQUEST_GET_SEATS_AND_SLOTS_SUCCESS = "REQUEST_GET_SEATS_AND_SLOTS_SUCCESS";
export const REQUEST_GET_SEATS_AND_SLOTS_ERROR = "REQUEST_GET_SEATS_AND_SLOTS_ERROR";
export const REQUEST_GET_RESERVATIONS = "REQUEST_GET_RESERVATIONS";
export const REQUEST_GET_RESERVATIONS_SUCCESS = "REQUEST_GET_RESERVATIONS_SUCCESS";
export const REQUEST_GET_RESERVATIONS_ERROR = "REQUEST_GET_RESERVATIONS_ERROR";
export const REQUEST_CREATE_RESTAURANT_CONFIG = "REQUEST_CREATE_RESTAURANT_CONFIG";
export const REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS = "REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS";
export const REQUEST_CREATE_RESTAURANT_CONFIG_ERROR = "REQUEST_CREATE_RESTAURANT_CONFIG_ERROR";
export const REQUEST_UPDATE_RESTAURANT_CONFIG = "REQUEST_UPDATE_RESTAURANT_CONFIG";
export const REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS = "REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS";
export const REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR = "REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR";
export const REQUEST_CREATE_ALACARTE = "REQUEST_CREATE_ALACARTE";
export const REQUEST_CREATE_ALACARTE_SUCCESS = "REQUEST_CREATE_ALACARTE_SUCCESS";
export const REQUEST_CREATE_ALACARTE_ERROR = "REQUEST_CREATE_ALACARTE_ERROR";

/* BOOKINGAPP */
export const BOOKING_GET_LIST_DELTA = "BOOKING_GET_LIST_DELTA";
export const BOOKING_GET_LIST_DELTA_SUCCESS = "BOOKING_GET_LIST_DELTA_SUCCESS";
export const BOOKING_GET_LIST_DELTA_ERROR = "BOOKING_GET_LIST_DELTA_ERROR";
export const BOOKING_GET_LIST_WITH_FILTER = "BOOKING_GET_LIST_WITH_FILTER";
export const BOOKING_GET_LIST_WITH_ORDER = "BOOKING_GET_LIST_WITH_ORDER";
export const BOOKING_GET_LIST_SEARCH = "BOOKING_GET_LIST_SEARCH";
export const BOOKING_ADD_ITEM = "BOOKING_ADD_ITEM";
export const BOOKING_ADD_ITEM_SUCCESS = "BOOKING_ADD_ITEM_SUCCESS";
export const BOOKING_ADD_ITEM_ERROR = "BOOKING_ADD_ITEM_ERROR";
export const BOOKING_CREATE_ITEM = "BOOKING_CREATE_ITEM";
export const BOOKING_CREATE_ITEM_SUCCESS = "BOOKING_CREATE_ITEM_SUCCESS";
export const BOOKING_CREATE_ITEM_ERROR = "BOOKING_CREATE_ITEM_ERROR";
export const CHANGE_LANGUAGE_FOR_BOOKING_ITEMS = "CHANGE_LANGUAGE_FOR_BOOKING_ITEMS";
export const BOOKING_SHOW_TOAST_SET = "BOOKING_SHOW_TOAST_SET";
export const BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS = "BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS";
export const BOOKING_INVOKE_KEY = "BOOKING_INVOKE_KEY";
export const BOOKING_INVOKE_KEY_SUCCESS = "BOOKING_INVOKE_KEY_SUCCESS";
export const BOOKING_INVOKE_KEY_ERROR = "BOOKING_INVOKE_KEY_ERROR";

/* SERVICES */
export const SERVICE_GET_LIST = "SERVICE_GET_LIST";
export const SERVICE_GET_LIST_SUCCESS = "SERVICE_GET_LIST_SUCCESS";
export const SERVICE_GET_LIST_ERROR = "SERVICE_GET_LIST_ERROR";
export const SERVICE_GET_LIST_SEARCH = "SERVICE_GET_LIST_SEARCH";
export const SERVICE_GET_LIST_WITH_ORDER = "SERVICE_GET_LIST_ORDER";
export const SERVICE_GET_LIST_WITH_FILTER = "SERVICE_GET_LIST_ORDER";

/* LOL */
export const LOL_REQUESTS_WITH_FILTER = "LOL_REQUESTS_WITH_FILTER";
export const LOL_REQUESTS_WITH_ORDER = "LOL_REQUESTS_WITH_ORDER";
export const LOL_REQUESTS_SEARCH = "LOL_REQUESTS_SEARCH";

/* Template */

export const TEMPLATE_GET_ITEM = "TEMPLATE_GET_ITEM";
export const TEMPLATE_GET_ITEM_SUCCESS = "TEMPLATE_GET_ITEM_SUCCESS";
export const TEMPLATE_GET_ITEM_ERROR = "TEMPLATE_GET_ITEM_ERROR";
export const TEMPLATE_ADD_MESSAGE = "TEMPLATE_ADD_MESSAGE";
export const TEMPLATE_ADD_MESSAGE_SUCCESS = "TEMPLATE_ADD_MESSAGE_SUCCESS";
export const TEMPLATE_ADD_MESSAGE_ERROR = "TEMPLATE_ADD_MESSAGE_ERROR";

/* EASEE */

export const EASEE_GET_ADMIN_USERS = "EASEE_GET_USER";
export const EASEE_GET_ADMIN_USERS_SUCCESS = "EASEE_GET_USER_SUCCESS";
export const EASEE_GET_ADMIN_USERS_ERROR = "EASEE_GET_USER_ERROR";
